import React from "react";

export default function Header() {
  const items = [
    { href: "#interests", label: "About Me" },
    { href: "#research", label: "Research Areas" },
    { href: "#publications", label: "Publications" },
    { href: "#talks", label: "Talks" },
    { href: "#experience", label: "Work Experience" },
    { href: "#education", label: "Education" },
    { href: "#projects", label: "Projects" },
    { href: "#misc", label: "Miscellaneous" }
  ];
  return (
    <header className="header">
      <nav className="nav container">
        {items.map(i => (
          <a key={i.href} href={i.href}>{i.label}</a>
        ))}
      </nav>
    </header>
  );
}
